// Copyright 2025, University of Maryland, All Rights Reserved
export function AmendmentTypeGuide() {
  return (
    <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
      <h4 className="font-medium text-blue-800 dark:text-blue-200 mb-3">Amendment Type Guide</h4>
      <div className="space-y-2 text-sm text-blue-700 dark:text-blue-300">
        <div className="flex items-start gap-2">
          <span className="underline text-green-600 dark:text-green-400 font-medium shrink-0">Underline:</span>
          <span>indicates amendments to bill</span>
        </div>
        <div className="flex items-start gap-2">
          <span className="line-through text-red-600 dark:text-red-400 font-medium shrink-0">Strike:</span>
          <span>indicates matter stricken from the bill by amendment or deleted from the law by amendment</span>
        </div>
        <div className="flex items-start gap-2">
          <span className="italic text-orange-600 dark:text-orange-400 font-medium shrink-0">Italics:</span>
          <span>indicate opposite chamber/conference committee amendments</span>
        </div>
        <div className="mt-3 pt-2 border-t border-blue-200 dark:border-blue-700">
          <span className="font-medium">Note:</span> Multiple formatting types can apply to the same text
        </div>
      </div>
    </div>
  )
}
